import { FC, HTMLProps } from 'react';

import { useComponentId } from '@telialt/utils/src/hooks';

import { CapsuleShapedRadio, Diagonal, Unavailable } from './ChipChoice.styles';

type Props = { unavailable?: string } & HTMLProps<HTMLInputElement>;

export const ChipChoice: FC<Props> = ({
    checked,
    disabled,
    unavailable,
    id,
    children,
    className,
    hidden,
    ...htmlInputProps
}) => {
    const UID = 'chip-choice' + useComponentId();
    const ID = {
        input: id || UID + '--input',
        unavailable: UID + '--unavailable',
    };

    return (
        <CapsuleShapedRadio className={className} hidden={hidden}>
            <input
                {...htmlInputProps}
                id={ID.input}
                type="radio"
                aria-describedby={unavailable ? ID.unavailable : undefined}
                disabled={disabled}
                checked={checked}
            />

            <label htmlFor={ID.input}>
                {children} {unavailable && <Diagonal />}
            </label>
            <Unavailable aria-hidden={true} id={ID.unavailable}>
                {unavailable}
            </Unavailable>
        </CapsuleShapedRadio>
    );
};
